import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';

export const StyledDatagrid = styled(Datagrid)({
  '& .column-logo': { width: 0, padding: '0 16px', textAlign: 'center', verticalAlign: 'middle' },
  '& .column-requestFormAmount': { textAlign: 'center' },
});
